export default {
    version: '2.0.1',
    bugsnagKey: '711a2f35876ccfa8216a47075bcbc252',
    brightcove: {
        accountID: '3887645597001',
        playerId: 'CbHZIY3yE',
    },
    wistia: {
        scriptURL: '//fast.wistia.com/assets/external/E-v1.js',
    },
    breakpoint: {
        small: '568',
        medium: '767',
        large: '1024',
        xlarge: '1280',
    },
}
